function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icons-/-temperature-thermometer",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "temperature-thermometer",
  transform: "translate(2.000000, 3.000000)",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.8897059,22.4500358 L11.8897059,4.60485934 C11.8897058,2.07084699 9.81573079,0.0166241376 7.25735294,0.0166241376 C4.69897509,0.0166241376 2.62500005,2.07084699 2.625,4.60485934 L2.625,22.4500358 C0.477650374,24.3523918 -0.261765564,27.3699218 0.766228829,30.0356144 C1.79422322,32.701307 4.3763811,34.4621918 7.25735294,34.4621918 C10.1383248,34.4621918 12.7204827,32.701307 13.7484771,30.0356144 C14.7764714,27.3699218 14.0370555,24.3523918 11.8897059,22.4500358 Z",
  id: "Path",
  stroke: "#485156"
}), /*#__PURE__*/React.createElement("line", {
  x1: 7.26198529,
  y1: 14.9283887,
  x2: 7.26198529,
  y2: 25.2519182,
  id: "Path",
  stroke: "#425CD4"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval",
  stroke: "#425CD4",
  cx: 7.26198529,
  cy: 27.5460358,
  rx: 2.31617647,
  ry: 2.29411765
}), /*#__PURE__*/React.createElement("line", {
  x1: 17.6847794,
  y1: 4.60485934,
  x2: 25.7913971,
  y2: 4.60485934,
  id: "Path",
  stroke: "#485156"
}), /*#__PURE__*/React.createElement("line", {
  x1: 17.6847794,
  y1: 11.4872123,
  x2: 21.1590441,
  y2: 11.4872123,
  id: "Path",
  stroke: "#485156"
}), /*#__PURE__*/React.createElement("line", {
  x1: 17.6847794,
  y1: 18.3695652,
  x2: 25.7913971,
  y2: 18.3695652,
  id: "Path",
  stroke: "#485156"
})));
function SvgTemperatureThermometer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "40px",
    viewBox: "0 0 30 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / temperature-thermometer") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperatureThermometer);
export default __webpack_public_path__ + "static/media/temperature-thermometer.76a697aab7fd6050826622d3296ccc1c.svg";
export { ForwardRef as ReactComponent };